import { X } from 'lucide-react'
import { SearchBar } from './SearchBar'
import { ActiveFilterChips } from './ActiveFilterChips'
import { AddFilterButton } from './AddFilterButton'
import { ColumnVisibilityDropdown } from './ColumnVisibilityDropdown'
import { useDashboardStore } from '../stores/dashboardStore'

export function TableToolbar() {
  const hasAnyFilter = useDashboardStore((s) =>
    s.statusFilter.length > 0 ||
    s.employeeFilter.length > 0 ||
    s.templateFilter.length > 0 ||
    !!s.orderDateFrom || !!s.orderDateTo ||
    !!s.deliveryDateFrom || !!s.deliveryDateTo ||
    s.orderIdFrom !== null || s.orderIdTo !== null ||
    s.customerNameFilter.length > 0 ||
    s.referenceFilter.length > 0 ||
    s.yourRefFilter.length > 0 ||
    s.infoFilter.length > 0 ||
    s.phoneFilter.length > 0 ||
    s.emailFilter.length > 0 ||
    s.customerIdFilter.length > 0 ||
    s.deliveryNameFilter.length > 0
  )
  const clearAllFilters = useDashboardStore((s) => s.clearAllFilters)

  return (
    <div className="flex items-center gap-2 px-4 py-2.5 border-b border-gray-200">
      <div className="w-80 flex-shrink-0">
        <SearchBar />
      </div>
      <ActiveFilterChips />
      <AddFilterButton />
      {hasAnyFilter && (
        <button
          onClick={clearAllFilters}
          className="flex items-center gap-1 text-[12px] px-2.5 py-1.5 rounded-md border border-gray-200 text-gray-500 hover:text-gray-700 hover:border-gray-300 transition-colors whitespace-nowrap"
        >
          <X size={12} />
          Nullstill
        </button>
      )}
      <div className="flex-1" />
      <ColumnVisibilityDropdown />
    </div>
  )
}
